import script from "./DebriefLearningOutcomesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DebriefLearningOutcomesPanel.vue?vue&type=script&setup=true&lang=js"

import "./DebriefLearningOutcomesPanel.vue?vue&type=style&index=0&id=da889f6c&lang=css"

const __exports__ = script;

export default __exports__